import { Config } from "../../../api/config";
export var AreaFieldReportsKeys = {
    Paging: 'AreaFieldReportsPaging',
    create: 'AreaFieldReportsCreate',
    update: 'AreaFieldReportsPagingUpdate',
    get: 'AreaFieldReportsDetailsGetById',
    count: 'AreaFieldReportsCount',
    ManualSearchGetData: "AreaFieldReportsManualSearch",
    tempCondList: 'TemperatureConditionList',
    download: 'AreaFieldReportsDownload',
    GetWarrantyList: 'GetWarrantyListData',
    upload: 'AreaFieldReportAttachment',
    getValue: 'getAttachmentValue',
    getFFRChildData: 'FieldFailureReportsChildAndParent',
    getAFRChildData: 'FieldFailureReportsChildAndParent',
    getHistoryData: 'FieldFailureReportsHistory',
    getDashboard: "DashboardCountForASM",
    getDashboardASMAFR: "DashboardCountAFRASM",
    getCatalogueFFR: "CatalogueFFR",
    updateDashboardCount: "updateDashboardCount",
    updateDashboardCountAFR: "updateDashboardCountAFR",
    ASMRemarks: "FFRASMRemarks",
    getChildAndParentData: 'FieldFailureReportsChildAndParent',
    MultipleASMRemarks: "FieldFailureReportsMultipleASMRemarks",
    ResendRemarks: "FieldFailureReportMultipleRemarks",
    FFRPaging: "FieldFailureReportPaging"
};
export var getFieldFailureDashboard = "".concat(Config.baseURL, "FieldFailureReport/DashboardCountForASM");
export var getAreaFieldDashboard = "".concat(Config.baseURL, "AreaFieldReport/DashboardCountForASM");
export var getFFRCatalogue = "".concat(Config.baseURL, "FieldFailureReport/Paging");
export var updateDashboardCount = "".concat(Config.baseURL, "FieldFailureReport/DashboardCountForASM");
export var updateDashboardCountAFR = "".concat(Config.baseURL, "AreaFieldReport/DashboardCountForASM");
export var AreaFieldReportsPagingURL = "".concat(Config.baseURL, "AreaFieldReport/Paging");
export var AreaFieldFailureReportsDetailsURL = function (id) { return "".concat(Config.baseURL, "AreaFieldReport/").concat(id, "/Get"); };
export var FieldFailureReportsChildURL = "".concat(Config.baseURL, "FieldFailureReport/ChildPagingForASM");
export var AreaFieldFailureReportsChildURL = "".concat(Config.baseURL, "AreaFieldReportChild/Paging");
export var areaFieldReportsDetailsGetByIdAPI = function (id) { return "".concat(Config.baseURL, "AreaFieldReport/").concat(id, "/Get"); };
export var FFRAreaRemarks = function () { return "".concat(Config.baseURL, "AreaFieldReport/Create"); };
export var FieldFailureReportsChildAndParentURL = "".concat(Config.baseURL, "FieldFailureReport/ChildPagingForASM");
export var FieldFailureReportsHistoryURL = "".concat(Config.baseURL, "FieldFailureReportHistory/Paging");
export var AreaFieldReportsChildAndParentURL = "".concat(Config.baseURL, "AreaFieldReportChild/Paging");
export var AreaFieldReportsHistoryURL = "".concat(Config.baseURL, "AreaFieldReportHistory/Paging");
export var PriorityPickListURL = "".concat(Config.baseURL, "PriorityPickList/PickList");
export var CategoryPickListURL = "".concat(Config.baseURL, "CategoryPickList/PickList");
export var DealerIdListURL = function (id) { return "".concat(Config.baseURL, "AreaFieldReport/").concat(id, "/ChildDealerFFR"); };
export var AreaFieldReportsUpdateURL = function (id) { return "".concat(Config.baseURL, "AreaFieldReport/").concat(id, "/Update"); };
export var UpdateRemarks = function () { return "".concat(Config.baseURL, "FieldFailureReport/UpdateFFRStatus"); };
export var AreaFieldReportsCreateAttachment = "".concat(Config.baseURL, "AreaFieldReportCourierAttachment/Create");
export var AreaFieldReportsAttachmentSingleValue = function (id, schemaId) { return "".concat(Config.baseURL, "resource/").concat(schemaId, "/").concat(id); };
export var AreafieldFailureReportSubmit = "".concat(Config.baseURL, "AreaFieldReport/Submit");
